// extracted by mini-css-extract-plugin
export default {"header":"MetaDataCard_header__IaOpa","title":"MetaDataCard_title__L0QI6","text":"MetaDataCard_text__15Wib","body":"MetaDataCard_body__7awCz","grey":"MetaDataCard_grey__krwk0"};